import { VTab, VTabTrigger, VTabTriggerContainer } from '../VTab';
import { useVPeriodSelectorContext } from './hook';

export const VRangePivot = () => {
  const {
    dateRangeTabList: dateRangeTabListPreset,
    periodUnitValue,
    rangePivot,
    onRangePivotChange,
  } = useVPeriodSelectorContext();

  return (
    <VTab
      defaultValue={dateRangeTabListPreset[periodUnitValue][0].value + ''}
      value={rangePivot.value + ''}
      onValueChange={val =>
        onRangePivotChange({
          unit: dateRangeTabListPreset[periodUnitValue].find(({ value }) => {
            return +val === value;
          })!.unit,
          value: +val,
        })
      }
      size="small"
      variant="secondary"
    >
      <VTabTriggerContainer>
        {dateRangeTabListPreset[periodUnitValue].map(({ value, label }) => (
          <VTabTrigger key={value} value={value + ''}>
            {label}
          </VTabTrigger>
        ))}
      </VTabTriggerContainer>
    </VTab>
  );
};
